export default __webpack_public_path__ + "static/media/victory.2f808c0b.png";